// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header__X1faH","title":"Header-module__title__6wsyL","button":"Header-module__button__e4Kak"};